module.exports = __webpack_public_path__ + "static/media/barber3.a978c41d.jpg";